import { Button } from '@lognai/synapse-design-system-v2';
import { Maximize2 } from '@lognai/synapse-design-system-v2/icons';

export function VisualEnlargeButton({
  title,
  onEnlarge,
  disabled = false,
}: {
  title: string;
  onEnlarge: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="xs"
      className="pointer-events-none shrink-0 opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100 focus-visible:pointer-events-auto focus-visible:opacity-100"
      aria-label={`Enlarge ${title}`}
      title="Enlarge visual"
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onEnlarge();
      }}
    >
      <Maximize2 size={14} />
    </Button>
  );
}
